export default
{

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('window:tick', this.onTick)
    },

    mounted()
    {
        this.onResize()
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onResize()
        {

        },

        onTick()
        {

        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-loader/script.js